import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ index, label }) => (
  <div className="flex items-center gap-3 mb-5" data-testid={`section-tag-${index}`}>
    <span className="font-mono2 text-xs text-cyan-400 tracking-[0.25em]">{index}</span>
    <span className="h-px w-10 bg-cyan-400/50" />
    <span className="font-mono2 text-xs uppercase tracking-[0.25em] text-soft">{label}</span>
  </div>
);
